import { WebScraperJobStatus } from "../../../services/web-scraper.service";

interface JobStatusBadgeProps {
  status: WebScraperJobStatus;
}

const statusConfig: Record<WebScraperJobStatus, { label: string; classes: string }> = {
  [WebScraperJobStatus.NOT_STARTED]: { label: "Not Started", classes: "bg-gray-100 text-gray-600" },
  [WebScraperJobStatus.RUNNING]:     { label: "Running",     classes: "bg-blue-100 text-blue-700 animate-pulse" },
  [WebScraperJobStatus.PAUSED]:      { label: "Paused",      classes: "bg-yellow-100 text-yellow-700" },
  [WebScraperJobStatus.DONE]:        { label: "Done",        classes: "bg-green-100 text-green-700" },
  [WebScraperJobStatus.FAILED]:      { label: "Failed",      classes: "bg-red-100 text-red-700" },
};

export default function JobStatusBadge({ status }: JobStatusBadgeProps) {
  const config = statusConfig[status] ?? { label: status, classes: "bg-gray-100 text-gray-600" };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.classes}`}>
      {config.label}
    </span>
  );
}
